// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"88aec400","692":"a591add8"}[chunkId] + ".chunk.css";
};